import type {getConnectedOrganizationsParams} from '$server/domain/connect/models'
import type {RegistrationStatus} from '$share/types/asset'
import type {ConsentRequestType} from '$share/types/connect/common'
import type {z} from 'zod'

export type GetConnectedOrganizationsParams = z.infer<typeof getConnectedOrganizationsParams>

export enum ConnectOrganizationType {
    Bank = 'bank',
    SavingBank = 'savingBank',
    Card = 'card',
    Invest = 'invest',
    Insurance = 'insurance',
    GInsurance = 'ginsurance', // 보증보험
    Capital = 'capital',
    Telecom = 'telecom',
}

// 전송요구내역 상태
export enum ConsentStatus {
    TEMPORAL_SAVE = 'T', // 연결전
    CONNECTED = 'C', // 연결
    KEEP = 'K', // 연결해제 (데이터 유지)
    DELETE = 'D', // 연결해제 (데이터 삭제)
}

export interface ConnectedAsset {
    id: number
    name: string
    nickname?: string
    status: RegistrationStatus
    num: string
    consent: boolean | null
}

export interface Consent {
    status: ConsentStatus
    scheduled: boolean
    fndCycle: string | null
    addCycle: string | null
    endDate: string
    holdingPeriod: string
    consentTransMemo: boolean | null
    consentMerchantNameRegno: boolean | null // 가맹점명/사업자등록번호 전송요구 여부 (카드/전금/통신업권 2차 인증시에만 설정)
    consentTransCategory: boolean | null
    consentRequestType: ConsentRequestType
}
